import React from "react";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  PRODUCT_STATUS,
  getProductStatus,
} from "../../Constants/productStatus";

// The small status label beside an item's name in the supplier's catalog.
// Nothing is shown for an active item — that's the normal state. Same
// tone-map pattern as KycStatusChip: one entry per status that has a label.
//
// "Paused" keeps the orange it always had. "Draft" is neutral grey: it isn't
// an error, just unfinished — the call to action beside it carries the ask.

const TONE = {
  [PRODUCT_STATUS.PAUSED]: {
    backgroundColor: "#FFF3E0",
    color: "#E65100",
  },
  [PRODUCT_STATUS.DRAFT]: {
    backgroundColor: "rgba(47, 43, 61, 0.08)",
    color: (theme) => theme.palette.customColors.primaryText,
  },
};

const ProductStatusChip = ({ product, sx }) => {
  const { t } = useTranslation("supplier-products");
  const status = getProductStatus(product);
  const tone = TONE[status];
  if (!tone) return null;

  return (
    <Chip
      label={t(`product_badge.${status}`)}
      size="small"
      sx={{
        ...tone,
        fontSize: "12px",
        fontWeight: 500,
        height: "22px",
        flexShrink: 0,
        ...sx,
      }}
    />
  );
};

export default ProductStatusChip;
